import React, { useEffect, useState } from "react";
import { useLocation, Link, useNavigate } from "react-router-dom";
import {
    Card,
    CardBody,
    CardTitle,
    Label,
    Input,
    Button,
    Form,
    FormFeedback,
    Spinner,
} from "reactstrap";
import { useForm, Controller } from "react-hook-form";
import { toast } from "react-hot-toast";

import {
    useLogofileUploadMutation,
    useCreateEditProfileMutation,
} from "../../service/index";

function CompanyProfile() {
    const location = useLocation();
    const { state: locationState } = location;
    const isEdit = !!locationState?.isEdit;
    // console.log("isEdit", isEdit)
    const {
        control,
        handleSubmit,
        formState: { errors },
        reset,
        setValue,
        register,
    } = useForm();
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [successMessage, setSuccessMessage] = useState("");
    const [reqlogoFile, reslogoFile] = useLogofileUploadMutation();
    const [reqcreateprofile, rescreateprofile] = useCreateEditProfileMutation();
    const [isRedirecting, setIsRedirecting] = useState(false);
    const navigate = useNavigate();
    const [fileId, setFileId] = useState(null);

    const [previewLogoPath, setPreviewLogoPath] = useState(
        locationState?.data?.companyLogo
    );

    // console.log("reslogoFile",reslogoFile);
    // console.log("logo",locationState.data?.companyLogo);
    const logofileId = locationState?.data?.logofile;

    const handleFile = async (e, name) => {
        const file = e.target.files[0];
        if (!file) return;

        let reqData;
        if (isEdit) {
            reqData = {
                createdBy: locationState?.data?.createdBy,
                file,
                imagetype: name,
                type: 99,
                fileId: logofileId,
            };
        } else {
            reqData = {
                createdBy: locationState?._id,
                file,
                imagetype: name,
                type: 99,
            };
        }
        // console.log("reqData", reqData)

        try {
            const result = await reqlogoFile(reqData).unwrap();
            const fileData = result?.data;

            if (!fileData || !fileData._id) {
                throw new Error("No file data returned");
            }

            setFileId(fileData._id);
            const path =
                fileData?.filePath || fileData?.filepath || fileData?.filename;
            if (!path) {
                throw new Error("File path missing from response");
            }

            setValue("companyLogo", path, { shouldValidate: true });
            setPreviewLogoPath(path);
            return path;
        } catch (error) {
            setErrorMessage("Error uploading logo");
            console.error("Error Uploading image file", error);
            return;
        }
    };

    const onSubmit = async (reqData) => {
        try {
            setIsLoading(true);
            setErrorMessage("");
            setSuccessMessage("");

            const logoName = reslogoFile?.data?.data?.filepath;

            const payload = {
                ...reqData,
                createdBy: locationState?._id,
                logofile: reslogoFile?.data?.data?._id,
                companyLogo: logoName,
                _id: isEdit ? locationState?.data?._id : undefined,
            };

            // console.log("payload", payload)

            await reqcreateprofile(payload);
        } catch (error) {
            console.error("Submission error:", error);
            setIsLoading(false);
        }
    };

    useEffect(() => {
        reset({
            companyName: locationState?.data?.companyName || "",
            companyLogo: locationState?.data?.companyLogo || "",
            phoneNumber: locationState?.data?.phoneNumber || "",
            address: locationState?.data?.address || "",
            gst: locationState?.data?.gst || "",
            pan: locationState?.data?.pan || "",
            cin: locationState?.data?.cin || "",
            pincode: locationState?.data?.pincode || "",
            email: locationState?.data?.email || locationState?.email || "",
        });
        if (isEdit && locationState?.data?.companyLogo) {
            setPreviewLogoPath(locationState.data?.companyLogo);
        }
    }, [isEdit]);

    useEffect(() => {
        if (rescreateprofile?.isSuccess) {
            toast.success(
                isEdit
                    ? "Company Profile Updated Successfully"
                    : "Company Profile Saved Successfully",
                {
                    position: "top-center",
                    duration: 3000,
                }
            );
            setSuccessMessage(
                isEdit ? "Profile Updated" : "Profile saved successfully"
            );
            setIsLoading(false);
            setIsRedirecting(true);

            const successTimeout = setTimeout(() => {
                setIsRedirecting(false);
                setSuccessMessage("");
                if (isEdit) {
                    navigate("/accountsettings");
                } else {
                    navigate("/");
                }
            }, 2000);

            return () => clearTimeout(successTimeout);
        }
    }, [rescreateprofile?.isSuccess]);

    useEffect(() => {
        if (rescreateprofile?.isError) {
            toast.error(
                rescreateprofile?.error?.data?.message ||
                "Failed to save company profile",
                {
                    position: "top-center",
                    duration: 3000,
                }
            );
            setErrorMessage(
                rescreateprofile?.error?.data?.message || "An error occurred"
            );
            setIsLoading(false);
        }
    }, [rescreateprofile?.isError]);

   

    return (
        <div className="blank-page">
            <div className="app-content content">
                <div className="content-wrapper">
                    <div className="content-body">
                        <div className="auth-wrapper auth-basic px-2">
                            <div className="auth-inner my-2">
                                <Card className="mb-0">
                                    {successMessage && (
                                        <div className="message success-message">
                                            {successMessage}
                                        </div>
                                    )}
                                    {errorMessage && (
                                        <div className="message error-message">{errorMessage}</div>
                                    )}
                                    <CardBody>
                                        <CardTitle tag="h4" className="mb-1">
                                            {isEdit
                                                ? "Edit Company Profile"
                                                : "Create Company Profile"}
                                        </CardTitle>
                                        <Form
                                            className="auth-login-form mt-2"
                                            onSubmit={handleSubmit(onSubmit)}
                                        >
                                            <div className="mb-1">
                                                <Label>Company Name</Label>
                                                <Controller
                                                    name="companyName"
                                                    control={control}
                                                    rules={{ required: "Company name is required" }}
                                                    render={({ field }) => (
                                                        <Input
                                                            type="text"
                                                            invalid={!!errors.companyName}
                                                            {...field}
                                                        />
                                                    )}
                                                />
                                                {errors.companyName && (
                                                    <FormFeedback>
                                                        {errors.companyName.message}
                                                    </FormFeedback>
                                                )}
                                            </div>

                                            <div className="mb-1">
                                                <Label>Email</Label>
                                                <Controller
                                                    name="email"
                                                    control={control}
                                                    defaultValue={locationState?.email || ""}
                                                    rules={{
                                                        required: "Email is required",
                                                        pattern: {
                                                            value: /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/,
                                                            message: "Invalid email format",
                                                        },
                                                    }}
                                                    render={({ field }) => (
                                                        <Input
                                                            type="email"
                                                            invalid={!!errors.email}
                                                            {...field}
                                                        />
                                                    )}
                                                />

                                                {errors.email && (
                                                    <FormFeedback>{errors.email.message}</FormFeedback>
                                                )}
                                            </div>

                                            <div className="mb-1">
                                                <Label>Company Logo</Label>

                                                <input
                                                    type="hidden"
                                                    {...register("companyLogo", {
                                                        required: "Company logo is required",
                                                    })}
                                                />

                                                <Input
                                                    type="file"
                                                    accept="image/*"
                                                    invalid={!!errors.companyLogo}
                                                    onChange={async (e) => {
                                                        const uploadedPath = await handleFile(
                                                            e,
                                                            "brandLogo"
                                                        );
                                                        // console.log("Uploaded Path:", uploadedPath);
                                                        if (uploadedPath) {
                                                            setValue("companyLogo", uploadedPath, {
                                                                shouldValidate: true,
                                                            });
                                                            console.log(
                                                                "Set companyLogo in form:",
                                                                uploadedPath
                                                            );
                                                        } else {
                                                            // console.log("No path returned from handleFile");
                                                        }
                                                    }}
                                                />

                                                {errors.companyLogo && (
                                                    <FormFeedback>
                                                        {errors.companyLogo.message}
                                                    </FormFeedback>
                                                )}

                                                {previewLogoPath && (
                                                    <div className="mt-1">
                                                        <p>Current Logo:</p>
                                                        <img
                                                            src={previewLogoPath}
                                                            alt="Company Logo"
                                                            style={{
                                                                marginLeft: "100px",
                                                                maxWidth: "150px",
                                                                marginTop: "5px",
                                                                borderRadius: "8px",
                                                            }}
                                                        />
                                                    </div>
                                                )}
                                            </div>

                                            <div className="mb-1">
                                                <Label>Phone Number</Label>
                                                <Controller
                                                    name="phoneNumber"
                                                    control={control}
                                                    rules={{
                                                        required: "Phone number is required",
                                                        pattern: {
                                                            value: /^[0-9]{10}$/,
                                                            message: "Invalid phone number format",
                                                        },
                                                    }}
                                                    render={({ field }) => (
                                                        <Input
                                                            type="text"
                                                            invalid={!!errors.phoneNumber}
                                                            {...field}
                                                        />
                                                    )}
                                                />
                                                {errors.phoneNumber && (
                                                    <FormFeedback>
                                                        {errors.phoneNumber.message}
                                                    </FormFeedback>
                                                )}
                                            </div>
                                            <div className="mb-1">
                                                <Label>GST</Label>
                                                <Controller
                                                    name="gst"
                                                    control={control}
                                                    rules={{
                                                        required: "GST is required",
                                                       
                                                    }}
                                                    render={({ field }) => (
                                                        <Input
                                                            type="text"
                                                            invalid={!!errors.gst}
                                                            {...field}
                                                        />
                                                    )}
                                                />
                                                {errors.gst && (
                                                    <FormFeedback>
                                                        {errors.gst.message}
                                                    </FormFeedback>
                                                )}
                                            </div>
                                            <div className="mb-1">
                                                <Label>CIN</Label>
                                                <Controller
                                                    name="cin"
                                                    control={control}
                                                    rules={{
                                                        required: "CIN is required",
                                                       
                                                    }}
                                                    render={({ field }) => (
                                                        <Input
                                                            type="text"
                                                            invalid={!!errors.cin}
                                                            {...field}
                                                        />
                                                    )}
                                                />
                                                {errors.cin && (
                                                    <FormFeedback>
                                                        {errors.cin.message}
                                                    </FormFeedback>
                                                )}
                                            </div>
                                            <div className="mb-1">
                                                <Label>PAN Number</Label>
                                                <Controller
                                                    name="pan"
                                                    control={control}
                                                    rules={{
                                                        required: "Pan number is required",
                                                        
                                                    }}
                                                    render={({ field }) => (
                                                        <Input
                                                            type="text"
                                                            invalid={!!errors.pan}
                                                            {...field}
                                                        />
                                                    )}
                                                />
                                                {errors.pan && (
                                                    <FormFeedback>
                                                        {errors.pan.message}
                                                    </FormFeedback>
                                                )}
                                            </div>
                                            <div className="mb-1">
                                                <Label> Address </Label>
                                                <Controller
                                                    name="address"
                                                    control={control}
                                                    rules={{ required: "Address is required" }}
                                                    render={({ field }) => (
                                                        <Input
                                                            type="text"
                                                            invalid={!!errors.address}
                                                            {...field}
                                                        />
                                                    )}
                                                />
                                                {errors.address && (
                                                    <FormFeedback>{errors.address.message}</FormFeedback>
                                                )}
                                            </div>
                                            <div className="mb-1">
                                                <Label> Pincode </Label>
                                                <Controller
                                                    name="pincode"
                                                    control={control}
                                                    rules={{ required: "Pincode is required" }}
                                                    render={({ field }) => (
                                                        <Input
                                                            type="text"
                                                            invalid={!!errors.pincode}
                                                            {...field}
                                                        />
                                                    )}
                                                />
                                                {errors.pincode && (
                                                    <FormFeedback>{errors.pincode.message}</FormFeedback>
                                                )}
                                            </div>

                                            <Button
                                                color="primary"
                                                block
                                                disabled={isLoading || isRedirecting}
                                            >
                                                {isLoading || isRedirecting ? (
                                                    <Spinner size="sm" />
                                                ) : isEdit ? (
                                                    "Update Profile"
                                                ) : (
                                                    "Create Profile"
                                                )}
                                            </Button>
                                        </Form>
                                        {/* <p className="text-center mt-2">
                                            <span>Already have an account? </span>
                                            <Link to="/login">Login</Link>
                                        </p> */}
                                    </CardBody>
                                </Card>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CompanyProfile;
